module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_2_2.679e7c9c.png";